<template>
  <span class="badge-status" :class="ativo ? 'badge-status--ativo' : 'badge-status--inativo'">
    {{ ativo ? 'Ativo' : 'Inativo' }}
  </span>
</template>

<script>
export default {
  name: 'BadgeStatusProduto',
  props: {
    ativo: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.badge-status {
  display: inline-block;
  padding: 0.35rem 0.9rem;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  background: #fff;
  border: 1px solid #b8c0cc;
  color: #8a94a6;
}
.badge-status--ativo {
  border-color: #2f80ed;
  color: #2f80ed;
}
</style>
